import { isNotNullOrUndefined } from '@vy/utils';
import type { FilterOption } from '../../../../components/new-design/vyTableFilter';

export function collectUniqueOptions(values: (string | null | undefined)[]): FilterOption[] {
  const unique = new Set<string>();

  for (const value of values) {
    if (isNotNullOrUndefined(value) && value.length > 0) {
      unique.add(value);
    }
  }

  return Array.from(unique)
    .sort((a, b) => a.localeCompare(b))
    .map((value) => ({ value, label: value }));
}

export function collectIdNameOptions(
  entries: { id: string | null | undefined; name: string | null | undefined }[],
): FilterOption[] {
  const seen = new Map<string, string>();

  for (const entry of entries) {
    if (isNotNullOrUndefined(entry.id) && !seen.has(entry.id)) {
      seen.set(entry.id, entry.name ?? entry.id);
    }
  }

  return Array.from(seen, ([value, label]) => ({ value, label })).sort((a, b) =>
    a.label.localeCompare(b.label),
  );
}
